var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon",class:_vm.classes})
}
var staticRenderFns = []

export { render, staticRenderFns }